<template>
  <div class="map-wrap">
    <yandex-map
      :coords="coords"
      :zoom="zoom"
      :controls="controls"
      :scroll-zoom="false"
      style="width: 100%; height: 520px;"
      map-type="map"
      @click="setEvent"
    >
    </yandex-map>
  </div>
</template>

<script>
  export default {
    name: "Ymap",
    props: {
      coords: {
        type: Array
      },
      onEvent: {
        type: Boolean
      }
    },
    data() {
      return {
        zoom: 10,
        controls: [
          'zoomControl',
          'searchControl'
        ]
      }
    },
    methods: {
      getFill(coefficient) {
        let fill = {width: 2};

        if (coefficient < 0) {
          return  {...fill, color: "#ff0000"};
        }

        if (coefficient === 0) {
          return  {...fill, color: "#808080"};
        }

        if (coefficient > 0) {
          return  {...fill, color: "#00a550"};
        }
      },
      setEvent(e) {
        let coords = e.get('coords');
        if (this.onEvent) {
          this.$emit("onEventAdd", coords.join(','));
        } else {
          this.$emit("setEvent", coords.join(','));
        }
      }
    },
  };
</script>

<style>
  .map-wrap {
    width: 100%;
    margin-top: 3px;
  }
</style>
